import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import "styles/modal.css";

const UserViewModal = ({ isOpen, onClose, user, loading }) => {
  if (!isOpen) return null;

  const imageUrl = user?.imageUrl || null;

  const displayName =
    [user?.firstName, user?.lastName].filter(Boolean).join(" ").trim() ||
    user?.username ||
    "—";

  return (
    <AnimatePresence>
      <motion.div className="modal-backdrop" onClick={onClose}>
        <motion.div
          className="modal-content"
          onClick={(e) => e.stopPropagation()}
          style={{ maxWidth: "640px", borderRadius: "16px", padding: "28px" }}
        >
          <h3
            style={{ margin: "0 0 24px", fontSize: "22px", fontWeight: "700" }}
          >
            Foydalanuvchi ma'lumotlari
          </h3>

          {loading ? (
            <div style={{ textAlign: "center", padding: "80px 0" }}>
              Ma'lumotlar yuklanmoqda...
            </div>
          ) : user ? (
            <div className="user-detail-view">
              {/* Rasm */}
              <div style={{ textAlign: "center", marginBottom: "24px" }}>
                {imageUrl ? (
                  <img
                    src={imageUrl}
                    alt={displayName}
                    style={{
                      width: "160px",
                      height: "160px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      border: "4px solid #e0e7ff",
                      boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
                    }}
                    onError={(e) => (e.target.style.display = "none")}
                  />
                ) : (
                  <div
                    style={{
                      width: "160px",
                      height: "160px",
                      borderRadius: "50%",
                      background: "#e0e7ff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#6366f1",
                      fontWeight: "bold",
                      fontSize: "64px",
                      margin: "0 auto",
                      border: "4px solid #c7d2fe",
                    }}
                  >
                    {(user.firstName || user.username || "?")[0].toUpperCase()}
                  </div>
                )}
              </div>

              <div className="detail-row">
                <span className="label">Foydalanuvchi nomi:</span>
                <span>{user.username || "—"}</span>
              </div>

              <div className="detail-row">
                <span className="label">To‘liq ism:</span>
                <span>{displayName}</span>
              </div>

              <div className="detail-row">
                <span className="label">Telefon raqami:</span>
                <span>{user.phoneNumber || "—"}</span>
              </div>

              <div className="detail-row">
                <span className="label">Rol:</span>
                <span
                  style={{
                    padding: "4px 12px",
                    borderRadius: "12px",
                    color: "#16a34a",
                  }}
                >
                  {user.role || "User"}
                </span>
              </div>

              <div className="detail-row">
                <span className="label">Holati:</span>
                <span
                  style={{
                    padding: "6px 14px",
                    borderRadius: "20px",
                    color: user.state === "Active" ? "#10b981" : "#ef4444",
                    fontWeight: "600",
                  }}
                >
                  {user.state === "Active" ? "Faol" : "Faol emas"}
                </span>
              </div>

              <div className="detail-row">
                <span className="label">Bio / Haqida:</span>
                <span>{user.bio || "—"}</span>
              </div>

              <div className="detail-row">
                <span className="label">ID:</span>
                <span style={{ fontFamily: "monospace", fontSize: "13px" }}>
                  {user.id}
                </span>
              </div>
            </div>
          ) : (
            <p
              style={{
                textAlign: "center",
                padding: "60px 0",
                color: "#e74c3c",
              }}
            >
              Ma'lumot topilmadi
            </p>
          )}

          <div style={{ marginTop: "32px", textAlign: "right" }}>
            <button className="btn-cancel" onClick={onClose}>
              Yopish
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default UserViewModal;
